export default "__VITE_ASSET__9724c9f7__"